import React, { useEffect } from 'react'
import { loginSuccess } from '../../API/api'

export default function ExternalLogin() {
    useEffect(()=>{
        loginSuccess();
    },[])
  return (
    <div></div>
  )
}
